import { createContext, useContext } from "react";

import type { Customer } from "~/providers/customer-provider";

interface CustomerContext {
  customers: Customer[];
}

export const CustomerContext = createContext<CustomerContext | undefined>(
  undefined,
);

export const useCustomer = () => {
  const context = useContext(CustomerContext);

  if (context === undefined) {
    throw new Error(
      "useCustomer must be used within a CustomerProvider, but no provider was found",
    );
  }

  return context;
};
